// Date helpers for invoices. Dates are plain YYYY-MM-DD (no timezone).

export const todayIso = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

export const addDays = (iso: string, days: number) => {
  const d = new Date(`${iso}T12:00:00`);
  d.setDate(d.getDate() + days);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};

/** Whole days from today to `iso` (negative = in the past). */
export const daysUntil = (iso: string) =>
  Math.round(
    (new Date(`${iso}T12:00:00`).getTime() - new Date(`${todayIso()}T12:00:00`).getTime()) /
      86_400_000,
  );

export const formatDay = (iso: string | null) =>
  iso ? new Date(`${iso.slice(0, 10)}T12:00:00`).toLocaleDateString() : "—";

export const money = (amount: number | null | undefined, currency?: string | null) =>
  amount == null ? "—" : `${currency ? `${currency} ` : ""}${amount.toFixed(2)}`;
